// extracted by mini-css-extract-plugin
export default {"root":"Jks_fTe_Wd","header":"DBVmFrP4Cp","navigationBarWrapper":"_2f0HWEou6i","body":"xDFRzEEd72","loadingIndicator":"cJNQmTH5Ay"};